import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  id: string;
};

export async function getDeliveryApi({ id }: Data) {
  return makeRequest(Service.getDelivery(id, await identify()));
}
